import React from 'react';
import { Link } from 'react-router-dom';

const ShippingPolicy = () => {
  return (
    <div className="container mx-auto px-4 py-12 max-w-4xl">
      <h1 className="text-3xl font-bold text-gray-900 mb-2">Shipping Policy</h1>
      <p className="text-gray-500 text-sm mb-8">Last updated: June 2025</p>

      <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-8 space-y-8 text-gray-700 text-sm leading-relaxed">

        <section>
          <p className="text-base">
            At <strong>KLMKart (PK Agri)</strong>, we strive to deliver your orders safely and on time.
            Please review our shipping policy for information about delivery timelines, charges, and process.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-gray-900 mb-3">1. Shipping Partners</h2>
          <p>
            We partner with reliable logistics providers including Shiprocket and its associated courier
            network to deliver orders across India. The courier partner assigned to your order may vary based
            on your delivery location and order size.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-gray-900 mb-3">2. Delivery Timelines</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li><strong>Metro Cities:</strong> 3–5 business days</li>
            <li><strong>Tier 2 & Tier 3 Cities:</strong> 5–7 business days</li>
            <li><strong>Remote Areas:</strong> 7–12 business days</li>
          </ul>
          <p className="mt-3">
            These are estimated timelines and may vary due to logistics conditions, public holidays, weather,
            or other unforeseen circumstances. KLMKart is not responsible for delays caused by the courier partner.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-gray-900 mb-3">3. Shipping Charges</h2>
          <p>
            Shipping charges are calculated based on the weight, dimensions, and destination of your order.
            The exact shipping cost will be displayed at checkout before you confirm payment. We offer free
            shipping on orders above a certain threshold where applicable — this will be indicated on the
            product page or at checkout.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-gray-900 mb-3">4. Order Processing Time</h2>
          <p>
            Orders are processed within <strong>1–2 business days</strong> after successful payment
            confirmation. Orders placed on weekends or public holidays will be processed on the next
            business day.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-gray-900 mb-3">5. Tracking Your Order</h2>
          <p>
            Once your order is dispatched, you will receive an SMS with the tracking number and a link to
            track your shipment. You can also track your order through the{' '}
            <Link to="/orders" className="text-blue-600 hover:underline">My Orders</Link> section on our website.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-gray-900 mb-3">6. Delivery Issues</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>
              <strong>Failed Delivery:</strong> If delivery is attempted but unsuccessful (e.g., no one available),
              the courier may attempt re-delivery or hold the package at a local facility.
            </li>
            <li>
              <strong>Incorrect Address:</strong> Please ensure your delivery address is accurate at the time of
              order. KLMKart is not responsible for non-delivery due to incorrect address information.
            </li>
            <li>
              <strong>Lost/Damaged in Transit:</strong> In the rare event a package is lost or arrives damaged,
              please contact us within 3 days of the expected delivery date.
            </li>
          </ul>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-gray-900 mb-3">7. Bulk & Large Orders</h2>
          <p>
            For bulk orders (B2B or large quantity purchases), special shipping arrangements may apply.
            Please contact us directly for shipping quotes and timelines for large orders.
          </p>
        </section>

        <section className="border-t border-gray-100 pt-6">
          <h2 className="text-lg font-semibold text-gray-900 mb-3">Contact Us</h2>
          <div className="bg-gray-50 rounded-lg p-4 space-y-2">
            <p><strong>Company Name:</strong> KLMKart </p>
            <p><strong>Email:</strong> <a href="mailto:klmkartsales@gmail.com" className="text-blue-600 hover:underline">klmkartsales@gmail.com</a></p>
            <p><strong>Phone:</strong> <a href="tel:+917995004136 " className="text-blue-600 hover:underline">+91 7995004136 </a></p>
            <p><strong>Address:</strong> H.NO-8-5-136/12/P,T, S.R. COMPLEX, DURGA NAGAR X ROAD, MAILARDEVPALLY, RAJENDRANAGAR, Rangareddy</p>
          </div>
        </section>

      </div>
    </div>
  );
};

export default ShippingPolicy;